import { Box } from '@mui/material';
// import { useState } from 'react';
import ShareArticel from '@/components/resource/SocialShareCard';
import SignInCard from '@/components/resource/SignInCard';
import NewsletterSignupCard from '../resource/NewsletterSignupCard';
// import SubscribeCard from '@/components/resource/SubscribeCard';

const ResourcesRightSidebar = () => {
  return (
    <Box
      sx={{
        textAlign: 'left',
        position: 'sticky',
        top: 90,
        mb: 0,
        ml: 2,
      }}
      component={'aside'}
    >
      <ShareArticel />
      <SignInCard />
      {process.env.NEXT_PUBLIC_ENVIRONMENT !== 'production' ? (
        <NewsletterSignupCard />
      ) : null}
      {/* <SubscribeCard /> */}
    </Box>
  );
};

export default ResourcesRightSidebar;
